import React from 'react';

import { Label } from '@/src/ui';

const cellColors = {
    white: '#ffffff',
    black: '#000000',
    lightGray: '#f7f7f7',
    mediumGray: '#e1e1e1',
    lightGreen: '#65d865',
    lightRed: '#f37b7b',
    red: '#ff0000',
    yellow: '#ffff00',
    green: '#008000',
    blue: '#0000ff',
    redBorder: '#ebcccc',
    yellowBorder: '#ffe69c',
    greenBorder: '#c8e5bc',
    blueBorder: '#babaffff',
};

export const AnswerCell: React.FC<{ text: string; status: 'correct' | 'wrong' | 'na' }> = ({
    text,
    status,
}) => {
    let bg = cellColors.lightGray;
    let color = cellColors.black;
    if (status === 'correct') {
        bg = cellColors.lightGreen;
        color = cellColors.black;
    } else if (status === 'wrong') {
        bg = cellColors.lightRed;
        color = cellColors.black;
    }
    return (
        <Label
            color={bg}
            sx={{
                color,
                border: '1px solid #e1e1e1',
                borderRadius: 10,

                display: 'flex',
                boxSizing: 'border-box',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {text}
        </Label>
    );
};

const bandColor = (band?: string) => {
    const s = String(band ?? '')
        .trim()
        .toLowerCase();
    if (!s)
        return { bg: cellColors.lightGray, border: cellColors.mediumGray, color: cellColors.black };
    if (s.includes('exceeds')) {
        return { bg: cellColors.blue, border: cellColors.blueBorder, color: cellColors.white };
    }
    if (s.includes('at/above') || s === 'met')
        return { bg: cellColors.green, border: cellColors.greenBorder, color: cellColors.white };
    if (s.includes('near') || s.includes('nearly'))
        return { bg: cellColors.yellow, border: cellColors.yellowBorder, color: cellColors.black };
    return { bg: cellColors.red, border: cellColors.redBorder, color: cellColors.white };
};

export const ScoreCell: React.FC<{ value: number | null | string; band?: string }> = ({
    value,
    band,
}) => {
    const { bg, border, color = 'inherit' } = bandColor(band);
    const text = value == null || value === '' ? '–' : String(value);
    return (
        <Label
            color={bg}
            sx={{
                color,
                border: `1px solid ${border}`,
                borderRadius: 10,

                display: 'flex',
                boxSizing: 'border-box',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {text}
        </Label>
    );
};

export const HeaderCell: React.FC<{
    top: React.ReactNode;
    row2?: React.ReactNode;
    row3?: React.ReactNode;
    align?: 'left' | 'center' | 'right';
}> = ({ top, row2, row3, align = 'center' }) => (
    <div
        style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr',
            height: 66,
            alignItems: 'center',
            textAlign: align,
            lineHeight: 1.2,
            padding: '2px 0',
        }}
    >
        <div>{top}</div>
        <div>{row2 ?? ' '}</div>
        <div>{row3 ?? ' '}</div>
    </div>
);
